/* eslint-disable */
// @ts-nocheck
import { AnyAction } from 'redux';
import { reducerWrapper } from '../support/utils';
import {
  FETCH_APP_STATUS,
  UPDATE_USER_HAS_CLOSED_TRIAL_BANNER,
  UPDATE_USER_HAS_CLOSED_USAGE_BANNER,
  UPDATE_USER_HAS_REQUESTED_PLATFORM_UPGRADE,
} from '../actions/StatusActions';
import type { AppStatus } from '../../../../shared/types';

export type StatusDataModel = {
  status: AppStatus['status'];
  billing_metadata: AppStatus['data'];
  milestoneTarget: AppStatus['milestone_target'];
};

export type StatusReducer = {
  loading: boolean;
  error: any;
  data: StatusDataModel | null;
  user_has_closed_trial_banner: boolean | null;
  user_has_closed_usage_banner: boolean | null;
  user_has_requested_platform_upgrade: boolean | null;
};

export const INIT_STATE: StatusReducer = {
  loading: true,
  error: null,
  data: null,
  user_has_closed_trial_banner: null,
  user_has_closed_usage_banner: null,
  user_has_requested_platform_upgrade: null,
};

const transformApiResponseDataToStatusDataModel = (responseData: AppStatus): StatusDataModel | undefined => {
  if (responseData) {
    const { status, data, milestone_target } = responseData;
    return {
      status,
      billing_metadata: data,
      milestoneTarget: milestone_target,
    } as StatusDataModel;
  }
};

const Handler = (state: StatusReducer, action: AnyAction): StatusReducer => {
  switch (action.type) {
    case FETCH_APP_STATUS.response:
      return {
        ...state,
        loading: false,
        data: transformApiResponseDataToStatusDataModel(action.data.data) || state.data,
      };
    case UPDATE_USER_HAS_CLOSED_TRIAL_BANNER:
      return {
        ...state,
        loading: false,
        user_has_closed_trial_banner: true,
      };
    case UPDATE_USER_HAS_CLOSED_USAGE_BANNER:
      return {
        ...state,
        loading: false,
        user_has_closed_usage_banner: true,
      };
    case UPDATE_USER_HAS_REQUESTED_PLATFORM_UPGRADE:
      return {
        ...state,
        loading: false,
        user_has_requested_platform_upgrade: true,
      };

    default:
      return state;
  }
};

const Status = reducerWrapper(INIT_STATE, Handler, {
  request: [],
  error: [],
});

export default Status;
